<div class="area-atuacao-container">
    <!--        -->

    @if (carregando()) {
        <div class="feedback">Carregando dados...</div>
    } @else if (erroConsulta()) {
        <div class="feedback erro">{{ erroConsulta() }}</div>
    } @else if (!dados()) {
        <div class="feedback">Nenhum dado disponível para este protocolo.</div>
    } @else {
        <div class="secoes">
            @for (secao of secoes; track secao.titulo) {
                <app-card-content [headerColor]="false" [title]="secao.titulo" [icon]="iconeDaSecao(secao.titulo)" [subtitle]="subtituloDaSecao(secao.titulo)">
                    <div class="secao-corpo">
                        <div class="campos-grid" [class.campos-grid--solicitante]="secao.titulo === 'Dados do Solicitante'">
                            @for (campo of secao.campos; track campo.label) {
                                @if (secaoEhDeDados(secao.titulo)) {
                                    <div class="field">
                                        <label class="font-semibold block mb-2" [for]="idDoCampo(secao.titulo, campo.label)">{{ campo.label }}</label>
                                        <input pInputText [id]="idDoCampo(secao.titulo, campo.label)" class="w-full" [value]="valorCampo(campo)" disabled />
                                    </div>
                                } @else {
                                    <article class="campo" [class.campo--destaque-identificacao]="deveDestacarIdentificacao(secao.titulo, campo.chave)" [class.campo--situacao]="campo.chave === 'situacao'">
                                        <span class="campo-label">{{ campo.label }}</span>
                                        <div class="campo-valor-box">
                                            @if (campo.chave === 'situacao') {
                                                <span class="situacao-badge" [class]="classeBadgeSituacao()" [attr.data-situacao]="valorCampo(campo)">
                                                    {{ valorCampo(campo) }}
                                                </span>
                                            } @else {
                                                <strong class="campo-valor">{{ valorCampo(campo) }}</strong>
                                            }
                                        </div>
                                    </article>
                                }
                            }
                        </div>
                    </div>
                </app-card-content>
            }

            <app-card-content [headerColor]="false" [title]="'Areas de Atuacao Solicitadas'" [icon]="iconeDaSecao('Areas de Atuacao Solicitadas')" [subtitle]="subtituloDaSecao('Areas de Atuacao Solicitadas')">
                <div class="secao-corpo">
                    @if (!areasAtuacao.length) {
                        <div class="feedback">Nenhuma área de atuação informada.</div>
                    } @else {
                        <div class="areas-lista">
                            @for (item of areasAtuacao; track $index) {
                                <article class="area-item">
                                    <div class="campos-grid">
                                        <div class="campo">
                                            <span class="campo-label">Área de Atuação</span>
                                            <div class="campo-valor-box">
                                                <strong class="campo-valor">{{ valorCampoArea(item, 'areaAtuacao') }}</strong>
                                            </div>
                                        </div>
                                        <div class="campo">
                                            <span class="campo-label">Especialidade</span>
                                            <div class="campo-valor-box">
                                                <strong class="campo-valor">{{ valorCampoArea(item, 'especialidade') }}</strong>
                                            </div>
                                        </div>
                                        <div class="campo">
                                            <span class="campo-label">Tipo Documento</span>
                                            <div class="campo-valor-box">
                                                <strong class="campo-valor">{{ valorCampoArea(item, 'tipoDocumentoEspecialidadeArea') }}</strong>
                                            </div>
                                        </div>
                                        <div class="campo">
                                            <span class="campo-label">Data Expedição Diploma</span>
                                            <div class="campo-valor-box">
                                                <strong class="campo-valor">{{ valorCampoArea(item, 'dataExpedicaoDiploma') }}</strong>
                                            </div>
                                        </div>
                                        <div class="campo campo--anexo">
                                            <span class="campo-label">Link Anexo</span>
                                            <div class="campo-valor-box campo-valor-box--anexo">
                                                @if (obterLinkAnexo(item); as linkAnexo) {
                                                    <button type="button" class="campo-link-botao" (click)="onVisualizarAnexo($event, item)" aria-label="Visualizar anexo" title="Visualizar anexo">
                                                        <i class="pi pi-paperclip"></i>
                                                        <span>Visualizar anexo</span>
                                                    </button>
                                                } @else {
                                                    <strong class="campo-valor">-</strong>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </article>
                            }
                        </div>
                    }
                </div>
            </app-card-content>
        </div>
    }
</div>

<p-dialog
    appDialogoPadrao="pi pi-paperclip"
    descricao="Documento anexado ao registro."
    [visible]="exibirDialogAnexo()"
    (visibleChange)="exibirDialogAnexo.set($event)"
    [style]="{ width: '90vw', maxWidth: '1200px' }"
    header="Visualização de anexo"
    (onHide)="fecharDialogAnexo()"
>
    @if (blobAnexo(); as blobAnexo) {
        <app-visualizador-pdf [src]="blobAnexo" [fileName]="nomeArquivoAnexo" [showAll]="false"></app-visualizador-pdf>
    } @else {
        <div class="feedback">Nenhum anexo disponível para visualização.</div>
    }
</p-dialog>
